import { useThemeStore } from './theme-store';
import type { BrandingConfig } from '@supernova/shared';

interface BrandingStore {
  config: BrandingConfig;
  setConfig: (config: BrandingConfig) => void;
}

/**
 * @deprecated Use useThemeStore instead for full theme management.
 * This wrapper maintains backward compatibility with existing consumers.
 */
export function useBrandingStore(): BrandingStore {
  const branding = useThemeStore((s) => s.branding);
  const setBranding = useThemeStore((s) => s.setBranding);
  return { config: branding, setConfig: setBranding };
}
